import { z } from "zod";

/**
 * Forgot Password Form Validation Schema
 * ------------------------------------------------------------
 * Validates the forgot password form fields using Zod
 * Fields:
 * - email: required, must be a valid email format
 */
export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .nonempty("Email is required") // Ensure the email field is not empty
    .min(1, "Email is required")   // Redundant safety check for minimum length
    .email("Invalid email address"), // Validate proper email format
});
